import PropTypes from 'prop-types';

import { propTypeShape as propTypeStyleTextfieldInner } from './styleTextfieldInner';
import { propTypeShape as propTypeStyleTextfieldOuter } from './styleTextfieldOuter';

const propTypeStyleTextfield = PropTypes.shape({
  ...propTypeStyleTextfieldInner,
  ...propTypeStyleTextfieldOuter,
});

export default propTypeStyleTextfield;
